import { defineMessages } from 'react-intl';

export default defineMessages({
	lblPlaceholder: {
		id: 'app.common.reactSelectWrapped.placeholder',
		defaultMessage: 'Select...',
	},
});
